import React from 'react';
import { Icon } from '@iconify/react/dist/iconify.js';
import '../styles/LoadingSpinner.css';

/**
 * Reusable loading spinner with a fish spinning in circles.
 * All black, clean and minimal.
 *
 * @param {string}  [message="Loading"]    - Text displayed below the spinner
 * @param {string}  [size]                 - Size variant: "sm", "lg", or "inline" (default is medium)
 * @param {boolean} [showProgressBar=true] - Whether to show the sliding progress bar
 * @param {string}  [className]            - Additional CSS class names
 */
const LoadingSpinner = ({
  message = 'Loading',
  size,
  showProgressBar = true,
  className = '',
}) => {
  const sizeClass = size ? `loading-${size}` : '';

  return (
    <div className={`loading-spinner-container ${sizeClass} ${className}`.trim()}>
      <div className="loading-fish-orbit">
        <div className="loading-orbit-ring" />
        <div className="loading-fish-icon">
          <Icon icon="ion:fish" />
        </div>
      </div>

      <div className="loading-text">
        {message}
        <span className="loading-dots">
          <span className="loading-dot" />
          <span className="loading-dot" />
          <span className="loading-dot" />
        </span>
      </div>

      {showProgressBar && (
        <div className="loading-progress-bar">
          <div className="loading-progress-fill" />
        </div>
      )}
    </div>
  );
};

export default LoadingSpinner;
